import type {Pagination} from 'src/openapi/admin/models/Pagination';

export const MAX_CACHED_RESULTS = 20;

export const DEFAULT_PAGE_SIZES = [25, 50, 100, 250];
export const DEFAULT_PAGINATION: Pagination = {
    currentPage: 1,
    pageSize: 50,
};
